import '../Header/Header.css'

const Header = () => {
    return <h1 className="header">U-Card</h1>
}

export default Header